import { StateCreator } from 'zustand';

import { exposeErrorReportingDevtools } from './devtools/exposeErrorReportingDevtools';
import { ErrorReportingClient } from './types/ErrorReportingClient';
import { ErrorReportingState } from './types/ErrorReportingState';

export const errorReportingStore =
  (client: ErrorReportingClient): StateCreator<ErrorReportingState> =>
  (set) => ({
    isInitialized: false,

    addBreadcrumb: ({ category, data, level, message, type }): void => {
      client.addBreadcrumb({
        category,
        data,
        level: level ?? 'info',
        message,
        timestamp: Date.now() / 1000,
        type,
      });
    },
    captureException: (error, context): void => {
      client.captureException(error, context);
    },
    init: (): void => {
      client.init();
      exposeErrorReportingDevtools(client);
      set({ isInitialized: true });
    },
    setAdditionalData: (data): void => {
      client.setExtras(data);
    },
    setTag: (key, value): void => {
      client.setTag(key, value);
    },
    setUser: (user): void => {
      client.setUser(user);
    },
    wrapCreateBrowserRouter: (createRouter) =>
      client.wrapCreateBrowserRouter(createRouter),
  });
